function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.33,
    height: 17.538,
    viewBox: "0 0 14.33 17.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1651",
    d: "M11.217 2H5.6A1.6 1.6 0 0 0 4 3.6v12.83a1.6 1.6 0 0 0 1.6 1.6h9.623a1.6 1.6 0 0 0 1.6-1.6V7.613z",
    transform: "translate(-3.25 -1.25)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1652",
    d: "M13 2v5.613h5.613",
    transform: "translate(-5.033 -1.25)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile21);
export default __webpack_public_path__ + "static/media/file (2) (1).7929936cd176a15f94cc8154d38ee15a.svg";
export { ForwardRef as ReactComponent };